var liveAddress = "https://regmagic.onrender.com/";

// var liveAddress = "http://localhost:3000/"
var socketRoute = liveAddress + "/websocket"
var webSocketAddress = "ws://localhost:8765/"

export const SERVER_URL = liveAddress;
export const WEBSOCKET_URL = webSocketAddress;
export const SocketRoute = socketRoute;
export const FileReadRoute = liveAddress + "readFile";

export const WEB_URL = "https://cad.proxelera.com/dashboard"
export const buyerRole = "buyer";
export const vendorRole = "vendor";
export const defaultRole = buyerRole;
export const appToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjYwNzAxODQ0ZGFiMTU0MmI5YjE2N2UxYiIsImlhdCI6MTYyMjQ2MTI0NywiZXhwIjoxNjMxMTAxMjQ3fQ.VMQL9YdaUMM6ET5_La9kN13CopmAMjMw0ZlIlk5gOAQ'


export const urls = {
    signup: SERVER_URL + "signup",
    project: SERVER_URL + "project",
    register: SERVER_URL + "user",
    login: SERVER_URL + "user",
    user: SERVER_URL + "user",
    fileInputs: SERVER_URL + "fileInputs",
    viewInputs: SERVER_URL + "project",
    viewOutputs: SERVER_URL + "project",
    fileOp: SERVER_URL + "fileOp",
    rtltop: SERVER_URL + "rtltop",
    readFile: SERVER_URL + "readfile",




};

